__turbopack_context__.v({
  "placeholderContainer": "RskFFW_placeholderContainer",
  "selectRestaurantButton": "RskFFW_selectRestaurantButton",
});
